import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueAwesomeSwiper from 'vue-awesome-swiper';
import { Message } from 'element-ui';
import Video from 'video.js'
import 'video.js/dist/video-js.css'

// require styles
import 'swiper/dist/css/swiper.css'
// external reference
import 'element-ui/lib/theme-chalk/index.css';

// user-defined
import './styles/index.scss';
import tools from './tools';
Vue.prototype.$tools = tools.newRouter;
Vue.prototype.$video = Video;

// is PC
if (tools.newUtils.isPC()) {
  store.commit("setIsPC", true);
} else {
  tools.remJs();
  store.commit("setIsPC", false);
};

Vue.use(VueAwesomeSwiper);
Vue.prototype.$message = Message;
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
